/**
 * 드래그된 블록과 대상 블록을 2단 columnList로 병합한다(DnD 컬럼 생성의 핵심 로직).
 *
 * 공개 블록 API(getBlock/removeBlocks/replaceBlocks)만 사용하므로 columnList/column이
 * 블록 스펙으로 등록돼 있어야 한다(이미 등록됨). 이벤트 처리(columnDnd 플러그인)와 분리해
 * 단독 테스트가 가능하다.
 *
 * @param side "left"  → [dragged | target], "right" → [target | dragged]
 * @returns 병합 성공 여부
 */
export function mergeBlocksIntoColumns(
  editor: any,
  draggedId: string,
  targetId: string,
  side: "left" | "right",
): boolean {
  if (!editor || !draggedId || !targetId || draggedId === targetId) {
    return false;
  }

  const dragged = editor.getBlock?.(draggedId);
  const target = editor.getBlock?.(targetId);
  if (!dragged || !target) {
    return false;
  }
  // 컬럼/컬럼리스트 자체는 드래그 대상에서 제외(중첩/해체 복잡도 회피, v1).
  if (
    dragged.type === "columnList" ||
    dragged.type === "column" ||
    target.type === "columnList" ||
    target.type === "column"
  ) {
    return false;
  }

  const columnList = {
    type: "columnList",
    children:
      side === "left"
        ? [
            { type: "column", children: [dragged] },
            { type: "column", children: [target] },
          ]
        : [
            { type: "column", children: [target] },
            { type: "column", children: [dragged] },
          ],
  };

  try {
    const run = () => {
      // 원본에서 드래그 블록 제거 후, 대상을 columnList로 교체(대상+드래그를 단으로).
      editor.removeBlocks([draggedId]);
      editor.replaceBlocks([targetId], [columnList]);
    };
    if (typeof editor.transact === "function") {
      editor.transact(run);
    } else {
      run();
    }
    return true;
  } catch {
    return false;
  }
}
